import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledCallouts = styled.div`
  display: grid;
  grid-row-gap: ${themeGet('scale.scaleUp03')};

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: ${themeGet('scale.scaleUp03')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavMd')}) {
    grid-template-columns: 1fr;
    grid-row-gap: ${themeGet('scale.scaleBase')};
  }
`;

export const StyledCallout = styled.div`
  background: ${themeGet('color.colorWhite')};
  display: grid;
  grid-template-columns: ${themeGet('scale.scaleUp12')} auto;
  align-items: center;
  transition: box-shadow 0.25s ease-out, transform 0.25s ease-out;
  cursor: pointer;
  backface-visibility: hidden;
  position: relative;
  transform: translateZ(0);

  a {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }

  &:hover {
    transform: scale(1.022);
    box-shadow: 0 8px 24px 0 rgba(44,74,125,0.1);
  }

  > div:last-of-type {
    ${themeGet('font.whitneySemibold')}
    padding: ${themeGet('scale.scaleUp03')} ${themeGet('scale.scaleUp01')};
    font-size: ${themeGet('scale.scaleDown02')};
    text-transform: uppercase;
    letter-spacing: 1px;
    color: ${themeGet('color.colorGrayBlue80')};

    ::after {
      content: '›';
      margin-left: 0.15em;
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    > div:last-of-type {
      padding: ${themeGet('scale.scaleUp03')} ${themeGet('scale.scaleUp05')};
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    > div:last-of-type {
      padding: ${themeGet('scale.scaleBase')};
    }
  }
`;
